import { Link } from "react-router-dom";
import { Callout, PageHeader, Panel } from "@vixio/ui";

/**
 * Painéis de infraestrutura de terceiros atrás do portão de login único (worker /gate/*): quem abre recebe o login do
 * Vixio OS (com 2FA, se ativado) e o portão confere o papel (administrador da plataforma ou admin/owner).
 */
export const INFRA_PANELS = [
  {
    href: "https://status.vixio.com.br/",
    title: "Status dos serviços",
    tool: "Uptime Kuma",
    text: "Monitores de disponibilidade do site, do painel, da API, do worker e dos serviços externos, com histórico de quedas e avisos.",
  },
  {
    href: "https://analytics.vixio.com.br/",
    title: "Estatísticas do site",
    tool: "Umami",
    text: "Visitas, páginas mais vistas, origens e eventos do site, sem cookies de rastreamento.",
  },
] as const;

export function InfraPanelsPage() {
  return (
    <div className="vx-content">
      <PageHeader
        title="Painéis de infraestrutura"
        description="Ferramentas de operação fora do Vixio OS. A entrada usa o mesmo login do painel e só vale para administradores."
      />
      <div className="vx-stack">
        {INFRA_PANELS.map((p) => (
          <Panel key={p.href} title={`${p.title} (${p.tool})`}>
            <div className="vx-stack">
              <p className="text-2">{p.text}</p>
              <p>
                <a href={p.href} target="_blank" rel="noopener">
                  Abrir {p.title.toLowerCase()}
                </a>{" "}
                <span className="muted mono">{new URL(p.href).host}</span>
              </p>
            </div>
          </Panel>
        ))}
        <Callout tone="info">
          O acesso vale por 12 horas neste navegador e termina quando você sai do painel. Para encerrar só o acesso aos
          painéis, use <Link to="/portao/sair">encerrar acesso aos painéis</Link>. Entradas concedidas e negadas ficam em
          Auditoria.
        </Callout>
      </div>
    </div>
  );
}
